import { useMemo } from 'react';
import { useGlobalStore } from '@/store/global';

export const useIsFullScreen = () => {
    const { dragDrawerWidth, dragDrawerMaxWidth } = useGlobalStore();
    const isFullScreen = useMemo(() => dragDrawerWidth >= dragDrawerMaxWidth, [dragDrawerWidth, dragDrawerMaxWidth]);
    return isFullScreen;
};
